import { render, staticRenderFns } from "./ProductImport.vue?vue&type=template&id=12a44350&scoped=true"
import script from "./ProductImport.vue?vue&type=script&lang=js"
export * from "./ProductImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a44350",
  null
  
)

export default component.exports